import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { portalApi, setPortalToken } from "@/lib/portalApi";
import { PortalFrame } from "@/pages/portal/PortalLogin";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { getErrorMessage } from "@/lib/errors";

/** The invitation link: the person chooses a password once, and is signed in. */
export default function PortalAccept() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    portalApi.post("/portal/invite-info", { token }).then(({ data }) => setInfo(data)).catch((err) => setError(getErrorMessage(err)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { const { data } = await portalApi.post("/portal/accept-invite", { token, password }); setPortalToken(data.access_token); navigate("/portal"); }
    catch (err) { setError(getErrorMessage(err)); } finally { setBusy(false); }
  };
  const mismatch = again.length > 0 && again !== password;
  return (
    <PortalFrame>
      {!info && error && <p className="text-center text-sm text-red-600" data-testid="portal-invite-error">{error}</p>}
      {!info && !error && <p className="text-center text-sm text-muted-foreground">Checking your link…</p>}
      {info && (
        <form onSubmit={submit} className="space-y-4" data-testid="portal-accept-form">
          <h2 className="text-center text-2xl font-bold tracking-tight">Welcome, {info.full_name}</h2>
          <p className="text-center text-sm text-muted-foreground" data-testid="portal-invite-party">{info.party_name} · {info.email}</p>
          <div><Label htmlFor="n-pass">Choose a password</Label><Input id="n-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="portal-new-password" />
            <p className="mt-1 text-[11px] text-muted-foreground">At least 10 characters, with letters and numbers.</p></div>
          <div><Label htmlFor="n-pass2">Type it again</Label><Input id="n-pass2" type="password" required value={again} onChange={(e) => setAgain(e.target.value)} className="mt-1.5" data-testid="portal-new-password-again" />
            {mismatch && <p className="mt-1 text-[11px] text-red-600" data-testid="portal-mismatch">The two passwords differ.</p>}</div>
          {error && <p className="text-xs text-red-600" data-testid="portal-accept-error">{error}</p>}
          <Button type="submit" disabled={busy || !password || password !== again} className="w-full" data-testid="portal-accept-submit">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Save and sign in</Button>
        </form>)}
    </PortalFrame>
  );
}
